<template>
    <aside
        class="calendar-wrap"
        :style="[{ top: top + 'px', left: left + 'px' }]"
        v-show="is_show"
    >
        <v-date-picker
            :min-date="new Date()"
            v-model="date"
            color="gray"
            is-dark
            @dayclick="dateSelected($event)"
        />
    </aside>
</template>

<script>
export default {
    name: "calendar-item",

    data() {
        return {
            is_show: false,
            left: 0,
            top: 0,
            date: new Date()
        };
    },

    props: {
        btn: {
            type: HTMLSpanElement,
            default: null
        }
    },

    methods: {
        show() {
            this.is_show = true;
            this.getPos();

            // setTimeout(() => {
            //     this.date = '2021-05-26';
            //     console.log(this.date)
            // }, 100);
        },

        hide() {
            this.is_show = false;
        },

        toggle() {
            if (this.is_show) {
                this.hide();
            } else {
                this.show();
            }
        },

        getPos() {
            // crossbrowser version

            if (this.btn === null) return;
            let box = this.btn.getBoundingClientRect();

            let body = document.body;
            let docEl = document.documentElement;

            let scrollTop =
                window.pageYOffset || docEl.scrollTop || body.scrollTop;
            let scrollLeft =
                window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

            let clientTop = docEl.clientTop || body.clientTop || 0;
            let clientLeft = docEl.clientLeft || body.clientLeft || 0;

            this.top =
                Math.round(box.top + scrollTop - clientTop + box.height) + 10;
            this.left = Math.round(box.left + scrollLeft - clientLeft);
        },

        dateSelected(e) {
            if (!e.el.classList.contains("is-disabled")) {
                // console.log(e)

                this.$emit("selected", {
                    date: e.id
                });
            }
        },

        handleClick(e) {
            if (!this.is_show) return;
            // console.log(e.target)
            let root_parent = document.body;
            let p = e.target.parentNode;
            let is_calendar_el = false;

            while (p !== root_parent) {
                var o = p;
                p = o.parentNode;
                if (
                    o.classList.contains("calendar-wrap") ||
                    o.classList.contains("calendar-btn")
                )
                    is_calendar_el = true;
            }

            if (!is_calendar_el) this.hide();

            // console.log(1)
        }
    },

    // mounted() {
    //     // this.getPos();
    //     // console.log(this.btn)

    // },

    created() {
        window.addEventListener("click", this.handleClick);
    },

    destroyed() {
        window.removeEventListener("click", this.handleClick);
    }
};
</script>

<style lang="scss">
@import "@/assets/sass/variable";

.calendar-wrap {
    position: absolute;
    z-index: 99;

    .vc-container {
        font-family: $font;

        --font-normal: 400;
        --font-medium: 400;
        --font-semibold: 400;
        --font-bold: 400;
        --text-xs: var(--small-size);
        --text-sm: var(--small-size);
        --text-base: var(--base-size);
        --text-lg: 2rem;
        --leading-snug: 1;
        --white: #fff;
        --black: #000;
        --gray-100: #f8f8f8;
        --gray-200: #f0f0f0;
        --gray-300: #efefef;
        --gray-400: #c0c0c0;
        --gray-500: #afafaf;
        --gray-600: #999;
        --gray-700: #000;
        --gray-800: #000;
        --gray-900: #000;
        --rounded: 0;
        --rounded-lg: 0;
        --rounded-full: 0;
        --shadow: none;
        --shadow-lg: none;
        --shadow-inner: none;

        .vc-header {
            padding: var(--padding);
        }

        .vc-weeks {
            padding: 0 var(--padding) var(--padding);
        }

        .vc-weekday {
            line-height: 1;
            padding: 0.5rem;
        }

        .vc-day-content {
            width: 3rem;
            height: 3rem;
            line-height: 3rem;
        }

        .vc-arrows-container {
            padding: var(--padding);
        }
    }
}
@media only screen and (max-width: 767px) {
    // --text-lg: 5rem;

    .calendar-wrap {
        right: var(--padding-x2) !important;
        left: unset !important;
    }
}
</style>
